export interface ApiResponse
{
	statusCode: number;
	message: string;
	data: any;
	page: any;
	errors: any;
}
